import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

export const assignmentsList = (params = {}) => Http.get(`/admin/test-assignments${serialize(params)}`)
export const assignmentStore  = (params = {}) => Http.post('/admin/test-assignments', params)
export const assignmentCancel = (id)           => Http.post(`/admin/test-assignments/${id}/cancel`)
